//react/redux
import { AiFillCheckCircle } from "react-icons/ai";
import { datadogLogs } from "@datadog/browser-logs";

//components
import Header from "../Common/header";  
const Success = ({
  tenantColor,
  tenantImage,
  tenantName,
  responseScan
}) => {
  datadogLogs.logger.info(
    `Process completed with the invitationId: ${responseScan?.ScanToken?.InvitationId}`,
    {
      invitationId: responseScan?.ScanToken?.InvitationId,
      tenantName: tenantName
    }
  );

  return (
    <>
      <Header
        responseScan={responseScan}
        tenantColor={tenantColor}
        tenantImage={tenantImage}
        tenantName={tenantName}
      />
      <section className="bg-white border rounded-lg border-[#DADADA] px-4 py-36 flex flex-col justify-center items-center gap-4 my-5">
        <AiFillCheckCircle size={150} className="text-[#1DB83F]" />
        <h2 className="text-2xl">Done!</h2>
        <p className="text-center text-sm">
          The authentication process is now complete. We will contact you if
          we have any questions about your authentication results.
        </p>
      </section>
    </>
  );
};

export default Success;
